import { render } from "./Modal.vue?vue&type=template&id=2352fcd7"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/houston-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/modal/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2352fcd7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2352fcd7', __exports__)) {
    api.reload('2352fcd7', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=2352fcd7", () => {
    api.rerender('2352fcd7', render)
  })

}


export default __exports__